import { render } from "./SmIconModalEditComponent.vue?vue&type=template&id=5a11edf6"
import script from "./SmIconModalEditComponent.vue?vue&type=script&lang=js"
export * from "./SmIconModalEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmIconModalEditComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a11edf6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a11edf6', __exports__)) {
    api.reload('5a11edf6', __exports__)
  }
  
  module.hot.accept("./SmIconModalEditComponent.vue?vue&type=template&id=5a11edf6", () => {
    api.rerender('5a11edf6', render)
  })

}


export default __exports__